import { createReducer, on } from '@ngrx/store';

import {
    SetCustomAppServiceId,
    SetCustomAppsRestApiName,
    SetCustomInstanceId,
    SetCustomSelectedEntityParentRecordId,
    SetCustomSelectedEntityUId,
} from '../actions';
import * as sessionActions from '../actions/session.actions';
import { customState } from '../states/custom.state';

export const CUSTOM_REDUCER_KEY = 'custom';

export const CUSTOM_REDUCER = createReducer(
    customState,
    on(sessionActions.SetCurrentOrganization, (state, { organization }) => ({
        ...state,
        currentOrganizationId: organization?.id,
    })),
    on(SetCustomInstanceId, (state, { instanceId }) => ({
        ...state,
        instanceId,
    })),
    on(SetCustomAppsRestApiName, (state, { appRestApiName, bridgeRestApiName }) => ({
        ...state,
        appRestApiName,
        bridgeRestApiName,
    })),
    on(SetCustomAppServiceId, (state, { appServiceId }) => ({
        ...state,
        appServiceId,
    })),
    on(SetCustomSelectedEntityUId, (state, { selectedEntityUId }) => ({
        ...state,
        selectedEntityUId,
    })),
    on(SetCustomSelectedEntityParentRecordId, (state, { selectedEntityParentRecordId }) => ({
        ...state,
        selectedEntityParentRecordId,
    })),
    on(sessionActions.SessionLogoutSuccessfull, () => customState)
);
